export function getApiErrorMessage (error, fallback = 'Something went wrong') {
  const data = error?.response?.data

  if (typeof data === 'string' && data.trim()) {
    return data
  }

  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message
  }

  if (typeof data?.error === 'string' && data.error.trim()) {
    return data.error
  }

  if (error?.message) {
    return error.message
  }

  return fallback
}
